import { Tour } from "nextstepjs";
export function getDeviceSpecificSide() {
  if (typeof window === "undefined") return "top";

  const width = window.innerWidth;
  const userAgent = navigator.userAgent.toLowerCase();
  const isIPhone = /iphone/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  // Range-based logic
  if (isIPhone) {
    if (width <= 360) return "top-left"; // iPhone SE, older small phones
    if (width <= 400) return "top-right"; // iPhone 12, Mini, etc.
    if (width <= 450) return "top-left"; // iPhone 14, Pro Max, etc.
  } else if (isAndroid) {
    if (width <= 415) return "top-right"; // Pixel 6/7/8
    if (width <= 360) return "top-left"; // Small Android phones
    if (width <= 430) return "top-right"; // Mid Android devices
  }
  // Fallback
  return "top";
}

const specificSide = getDeviceSpecificSide();

const dashboardGuide: any = [
  {
    tour: "welcome_to_sobeys",
    steps: [
      {
        icon: null,
        title: "Welcome to the New Sobeys Experience!",
        content:
          "Let’s take a quick tour to help you make the most of your Sobeys digital experience.",
        // selector: "#welcome_dashboard",
        isWelcomePage: true, //only for welcome page
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Browse through categories and find your favorite items easily.",
        selector: "#menu-item-1",
        hideOnMobile: true,
        side: "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Discover Flyer and Scene+ savings, limited-time deals, and featured products.",
        selector: "#menu-item-2",
        hideOnMobile: true,
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Discover our services and make your shopping experience easier with convenient options tailored for you.",
        selector: "#menu-item-3",
        hideOnMobile: true,
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Discover delicious recipes and save your favorites to My Recipe Lists for easy access anytime!",
        selector: "#menu-item-4",
        hideOnMobile: true,
        side: "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Set your preferred store to see content tailored relevant to your location.",
        selector: "#store_locator",
        side: "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 0,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content: "Create and manage shopping lists to stay organized.",
        selector: "#manage_list",
        side: "bottom-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: null,
        title: "",
        content:
          "Login and link your Scene+ card to see your points and personalized offers.",
        selector: "#points_and_account",
        side: "bottom-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      // {
      //   icon: null,
      //   title: "",
      //   content:
      //     "Look for products with a black Scene+ banner to find exclusive offers available when you scan your Scene+ card in-store.",
      //   selector: "#Scene_Card_exclusive_offers+1",
      //   side: specificSide,
      //   showControls: true,
      //   showSkip: true,
      //   pointerPadding: 5,
      //   pointerRadius: 10,
      // },
      // {
      //   icon: null,
      //   title: "",
      //   content:
      //     "Look for large promo badges highlighting special deals and promotions that you can enjoy in-store!",
      //   selector: "#new_lower_price",
      //   side: "top-left",
      //   showControls: true,
      //   showSkip: true,
      //   pointerPadding: 5,
      //   pointerRadius: 10,
      // },
      {
        icon: null,
        title: "",
        content:
          "Browse through categories and find your favorite items easily.",
        selector: "#Categories",
        side: "top",
        showControls: true,
        showSkip: true,
        pointerPadding: 0,
        pointerRadius: 10,
      },
    ],
  },
];

export default dashboardGuide;
